"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalculate = exports.calculateShoppingCart = exports.getTotalRemainingValue = exports.getTotalDiscountedValue = exports.getDiscountValue = exports.getItemTotal = void 0;
const helper_1 = require("../helper");
const getItemTotal = (item) => {
    const quantity = item.quantity || 1;
    const price = item.currentPrice || 0;
    return price * quantity;
};
exports.getItemTotal = getItemTotal;
const getDiscountValue = (discount, items) => {
    const discountableItems = items.filter((item) => {
        if (discount.appliesToDiscountedItems === false && item.hasDealPrice)
            return false;
        return item.isDiscountable !== false;
    });
    const overallValue = (0, helper_1.sum)(...discountableItems.map((item) => (0, exports.getItemTotal)(item)));
    if (!discountableItems.length)
        return { total: 0, applied: 0, remaining: discount.isPercentage ? 0 : discount.value };
    if (!discount.isPercentage) {
        const remaining = (0, helper_1.clamp)(discount.value - overallValue, 0, discount.value);
        return { total: overallValue, applied: discount.value - remaining, remaining };
    }
    const applied = overallValue * (discount.value / 100);
    return { total: overallValue, applied, remaining: 0 };
};
exports.getDiscountValue = getDiscountValue;
const getTotalDiscountedValue = (values) => {
    return (0, helper_1.sum)(...values.map((dc) => dc.applied));
};
exports.getTotalDiscountedValue = getTotalDiscountedValue;
const getTotalRemainingValue = (values) => {
    return (0, helper_1.sum)(...values.map((dc) => dc.remaining));
};
exports.getTotalRemainingValue = getTotalRemainingValue;
const calculateShoppingCart = (items, discounts) => {
    discounts = discounts || [];
    const total = (0, helper_1.sum)(...items.map((item) => (0, exports.getItemTotal)(item)));
    const discountValues = discounts.map((discount) => (0, exports.getDiscountValue)(discount, items));
    //const remaining = clamp(total - discount, 0, total);
    return { total, discountValues };
};
exports.calculateShoppingCart = calculateShoppingCart;
const useCalculate = (items, discounts) => {
    const { total, discountValues } = (0, exports.calculateShoppingCart)(items, discounts);
    const totalDiscounted = (0, exports.getTotalDiscountedValue)(discountValues);
    const totalRemainingDiscountValue = (0, exports.getTotalRemainingValue)(discountValues);
    return { total, discountValues, discount: totalDiscounted, remaining: totalRemainingDiscountValue };
};
exports.useCalculate = useCalculate;
